import axios from "axios";
const axiosInstance = axios.create({
  baseURL: "https://json-server-videos-lws.onrender.com/",
});
export default axiosInstance;
